export default {

    Companies: 'Company|Companies',
};
